import {
	EscalatedAlert,
	EscalatedAlertApi,
	EscalatedAlertLog,
	EscalatedAlertsInData,
	EscalatedAlertMonitorRequest,
	EscalatedAlertResolveRequest,
	EscalatedAlertEscalateRequest,
	EscalatedAlertCounts,
	EscalatedAlertCountsApi,
} from '@/api';
import { ApiUtils } from '@/common/ApiUtils';

export class EscalatedAlertApiService {
	public escalatedAlertApi: EscalatedAlertApi = new EscalatedAlertApi();
	public escalatedAlertCountsApi: EscalatedAlertCountsApi = new EscalatedAlertCountsApi();

	public async getEscalatedAlerts(
		options?: any,
	): Promise<{ escalatedAlerts?: EscalatedAlertsInData; errorMessage?: string }> {
		try {
			const response = await this.escalatedAlertApi.getEscalatedAlerts(options);
			return { escalatedAlerts: response.data };
		} catch (e) {
			return ApiUtils.handleApiError(e, 'Failed to fetch Escalated Alerts');
		}
	}

	public async getEscalatedAlertById(
		id: number,
		options?: any,
	): Promise<{ escalatedAlert?: EscalatedAlert; errorMessage?: string }> {
		try {
			const response = await this.escalatedAlertApi.getEscalatedAlertById(id, options);
			return { escalatedAlert: response.data };
		} catch (e) {
			return ApiUtils.handleApiError(e, `Failed to fetch Escalated Alert by id: ${id}`);
		}
	}

	public async setEscalatedAlertToMonitor(
		id: number,
		body: EscalatedAlertMonitorRequest,
		options?: any,
	): Promise<{ escalatedAlertLog?: EscalatedAlertLog; errorMessage?: string }> {
		try {
			const response = await this.escalatedAlertApi.setEscalatedAlertMonitor(id, body, options);
			return { escalatedAlertLog: response.data };
		} catch (e) {
			return ApiUtils.handleApiError(
				e,
				`Failed to set Escalated Alert with id '${id}' to 'monitor'`,
			);
		}
	}

	public async setEscalatedAlertToEscalate(
		id: number,
		body: EscalatedAlertEscalateRequest,
		options?: any,
	): Promise<{ escalatedAlertLog?: EscalatedAlertLog; errorMessage?: string }> {
		try {
			const response = await this.escalatedAlertApi.setEscalatedAlertEscalate(id, body, options);
			return { escalatedAlertLog: response.data };
		} catch (e) {
			return ApiUtils.handleApiError(
				e,
				`Failed to set Escalated Alert with id '${id}' to 'escalate'`,
			);
		}
	}

	public async setEscalatedAlertToResolve(
		id: number,
		body: EscalatedAlertResolveRequest,
		options?: any,
	): Promise<{ escalatedAlertLog?: EscalatedAlertLog; errorMessage?: string }> {
		try {
			const response = await this.escalatedAlertApi.setEscalatedAlertResolve(id, body, options);
			return { escalatedAlertLog: response.data };
		} catch (e) {
			return ApiUtils.handleApiError(
				e,
				`Failed to set Escalated Alert with id '${id}' to 'resolve'`,
			);
		}
	}

	public async getEscalatedAlertsCounts(
		options?: any,
	): Promise<{ escalatedAlertsCounts?: EscalatedAlertCounts; errorMessage?: string }> {
		try {
			const response = await this.escalatedAlertCountsApi.getEscalatedAlertsCountsByStatus(options);
			return { escalatedAlertsCounts: response.data };
		} catch (e) {
			return ApiUtils.handleApiError(e, `Failed to get Escalated Alerts Counts`);
		}
	}
}
